import { SectionContentItem } from "./SectionContentItem";

export default SectionContentItem;